export const FETCH_VEHICLE_SPARE_PART_NUMBERS = 'FETCH_VEHICLE_SPARE_PART_NUMBERS';

export const fetchVehicleSparePartNumbers = () => {
    return {
        type: FETCH_VEHICLE_SPARE_PART_NUMBERS,
    };
};
